import { HTMLAttributes } from 'react'
import { IconBrandGithub, IconBrandGoogle } from '@tabler/icons-react'
import { Button } from '@/components/ui/button'
import { useSocialSignIn } from '@/hooks/use-social-sign-in'
import { cn } from '@/lib/utils'

type SocialAuthButtonsProps = HTMLAttributes<HTMLDivElement> & {
  isLoading?: boolean
}

export function SocialAuthButtons({ className, isLoading, ...props }: SocialAuthButtonsProps) {
  const { socialSignIn, loading: signInLoading } = useSocialSignIn()
  
  const isDisabled = isLoading || signInLoading

  return (
    <div className={cn('flex items-center gap-2', className)} {...props}>
      <Button
        variant='outline'
        className='w-full'
        type='button'
        disabled={isDisabled}
        onClick={() => socialSignIn('google')}
      >
        <IconBrandGoogle className='h-4 w-4' /> Google
      </Button>
      <Button
        variant='outline'
        className='w-full'
        type='button'
        disabled={isDisabled}
        onClick={() => socialSignIn('github')}
      >
        <IconBrandGithub className='h-4 w-4' /> Github
      </Button>
    </div>
  )
} 